module.exports = __webpack_public_path__ + "media/images/exit-eaaf9a1aca58edfaac3d603393ca60b4.png";